export const allFields = [
    {name: 'ss_no', title: 'SS No', display: 1},
    {name: 'firstname', title: 'First Name', display: 1},
    {name: 'lastname', title: 'Last Name', display: 1},
    {name: 'department', title: 'Department', display: 1},
    {name: 'job_title', title: 'Job Title', display: 1},
    {name: 'status', title: 'Status', display: 1},
    {name: 'cell_phone', title: 'Cell Phone', display: 0},
    {name: 'work_phone', title: 'Work Phone', display: 0},
    {name: 'birthdate', title: 'Birthdate', display: 0},
    {name: 'original_hire_date', title: 'Hire Date (orig)', display: 0},
    {name: 'hire_date', title: 'Hire Date', display: 0},
    {name: 'absent', title: 'Absent', display: 0},
    {name: 'tenure_date', title: 'Tenure Date', display: 0},
    {name: 'address1', title: 'Address', display: 0},
    {name: 'city', title: 'City', display: 0},
    {name: 'state_id', title: 'State', display: 0},
    {name: 'province', title: 'Province', display: 0},
    {name: 'zip', title: 'Zip', display: 0},
    {name: 'country_id', title: 'Country', display: 0},
    {name: 'start_rate', title: 'Start Rate', display: 0},
    {name: 'earnings_rate', title: 'Earnings Rate', display: 0},
    {name: 'vacation_limit', title: 'Vacation Limit', display: 0},
    {name: 'vacation_used', title: 'Vacation Used', display: 0},
    {name: 'vacation_available', title: 'Vacation Available', display: 0},
    {name: 'last_worked_date', title: 'Last Worked Date', display: 0},
    {name: 'last_check_date', title: 'Last Check Date', display: 0},
    {name: 'termination_reason', title: 'Termination Reason', display: 0},
    {name: 'rehire_eligibility', title: 'Rehire Eligibility', display: 0},
    {name: 'rehire_eligibility_date', title: 'Rehire Eligibility Date', display: 0}
];

export function mergeFields(fieldOptions) {
    if (!fieldOptions) {
        fieldOptions = [];
    } else {
        fieldOptions = fieldOptions
            .filter(field => allFields.find(f => f.name === field.name))
            .sort((f1, f2) => f1 - f2);
    }

    for (const field of allFields) {
        if (!fieldOptions.find(f => f.name === field.name)) {
            const newField = Object.assign({sort_order: fieldOptions.length}, field);
            fieldOptions.push(newField);
        }
    }

    return fieldOptions;
}



// WEBPACK FOOTER //
// ./src/containers/Employees/fields.js